import { SET_CLOUD_RECORDS, DELETE_CLOUD_RECORDS_REQUEST, DELETE_CLOUD_RECORDS_SUCCESS, DELETE_CLOUD_RECORDS_FAILURE } from '../actions/type'

const initialState = {
    cloud_records: [],
    total: 1,
    page: 1,
    per_page: 10,
    last_page: 1,
    delete_status: null
}

const cloudRecords = (state = initialState, action) => {
    switch (action.type) {
        case SET_CLOUD_RECORDS: {
            const payload = action.payload;
            return { ...state, ...payload, delete_status: null };
        }
        case DELETE_CLOUD_RECORDS_REQUEST: {
            const payload = action.payload;
            return { ...state, ...payload, delete_status: 'request' };
        }
        case DELETE_CLOUD_RECORDS_SUCCESS: {
            const payload = action.payload;
            return { ...state, ...payload, delete_status: 'success' };
        }
        case DELETE_CLOUD_RECORDS_FAILURE: {
            return { ...state, delete_status: 'error' };
        }
        default:
            return state
    }
}

export default cloudRecords